import React from 'react';
import SideMenu from '../sideMenu'; 
import DashboardHeader from '../topbar';
import InfoCard from '../../components/InfoCard'; 
import Styles from "./styles.module.scss";
import avgTimeIcon from "../../assets/images/avg-time-icon.svg";
import positionsIcon from "../../assets/images/positions-icon.svg";
import closedPositionsIcon from "../../assets/images/closed-positions-icon.svg";
import activePositionsIcon from "../../assets/images/active-positions-icons.svg";


function TotalInfoCards(props: any) {
 
  return (
    <div>
    <section className="infoCardGrid">
        {/* <InfoCard title="Avg. Time to close a position">
          <div className={Styles.infoCardWrap}>
            <img src={avgTimeIcon}/>
          <h2>{props &&  props.countData && props.countData.avgPositionCloseTime ? props.countData.avgPositionCloseTime : 0} Days</h2>
          </div>
        </InfoCard> */}
        {/* <InfoCard title="Total positions">
        <div className={Styles.infoCardWrap}>
          <img src={positionsIcon}/>
          <h2>{props &&  props.countData && props.countData.totalPositionsCount ? props.countData.totalPositionsCount : 0}</h2>
        </div>
        </InfoCard> */}
        <InfoCard title="Total successfully closed">
        <div className={Styles.infoCardWrap}>
          <img src={closedPositionsIcon}/>
          <h2>{props &&  props.countData && props.countData.totalClosedPositionsCount ? props.countData.totalClosedPositionsCount : 0}</h2>
        </div>
        </InfoCard>
        <InfoCard title="Active positions">
        <div className={Styles.infoCardWrap}>
          <img src={activePositionsIcon}/>
          <h2>{props &&  props.countData && props.countData.activePositonsCount ? props.countData.activePositonsCount : 0}</h2>
        </div>
        </InfoCard>
    </section>
    <section className="infoCardGrid">
      <InfoCard title="Total Active Contracts">
        <div className={Styles.infoCardWrap}>
          <img src={activePositionsIcon}/>
          <h2>{props &&  props.chartData && props.chartData.totalActiveContracts ? props.chartData.totalActiveContracts : 0}</h2>
        </div>
      </InfoCard>
      <InfoCard title="Number of Clients">
        <div className={Styles.infoCardWrap}>
          <img src={activePositionsIcon}/>
          <h2>{props &&  props.chartData && props.chartData.numberOfClients ? props.chartData.numberOfClients : 0}</h2>
        </div>
      </InfoCard>
      <InfoCard title="Number of Candidates">
        <div className={Styles.infoCardWrap}>
          <img src={activePositionsIcon}/>
          <h2>{props &&  props.chartData && props.chartData.numberOfCandidates ? props.chartData.numberOfCandidates : 0}</h2>
        </div>
      </InfoCard>
      <InfoCard title="Number of Partners">
        <div className={Styles.infoCardWrap}>
          <img src={activePositionsIcon}/>
          <h2>{props &&  props.chartData && props.chartData.numberOfPartners ? props.chartData.numberOfPartners : 0}</h2>
        </div>
      </InfoCard>
    </section>
    </div>
  )
}

export default TotalInfoCards